import { oracleSearchInitialState } from '@modules/oracle/store/oracleSearchInitialState';
import { OracleSearchActionType } from './oracleActionType';
import { OracleSearchAction, OracleState } from './types';

export function oracleSearchReducer(
  state: OracleState,
  action: OracleSearchAction,
): OracleState {
  switch (action.type) {
    case OracleSearchActionType.SET_VISUAL: {
      return {
        ...state,
        visual: {
          ...state.visual,
          ...action.payload,
        },
      };
    }

    case OracleSearchActionType.SET_DATA: {
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    }

    case OracleSearchActionType.RESET: {
      return oracleSearchInitialState;
    }

    default:
      return state;
  }
}
